import axios from '@/request/http'
import global from '@/constants/Global.constants'

export default {
  dictfindById (params) {
    return axios.post(global.BASE_INFO + '/dict/findCodeInfo', params)
  },
  dictDelete (params) {
    return axios.post(global.BASE_INFO + '/dict/deleteCodeType', params)
  },
  dictDeleteCodeInfo (params) {
    return axios.post(global.BASE_INFO + '/dict/deleteCodeInfo', params)
  },
  dictInsert (params) {
    return axios.post(global.BASE_INFO + '/dict/insertCodeType', params)
  },
  dictUpadte (params) {
    return axios.post(global.BASE_INFO + '/dict/updateCodeType', params)
  }
}



// WEBPACK FOOTER //
// ./src/request/dictionary/dictionary.js